import Axios from "./axios";

const resource = "reseller-billing-informations";

export default {
	create(data) {
		return Axios.post(`${resource}`, data);
	}
}